const REGION_VIEWS = {
  ro: { center: [ 27.946529, 36.220780], zoom: 9,island_id: 1 }, // Ρόδος
  sy: { center: [24.913546, 37.438192], zoom: 12,island_id: 16 }, // Σύρος
  ko: { center: [27.287283, 36.890048], zoom: 12,island_id: 2 }, // Κως
  all: { center: [27.946529, 36.22078], zoom: 5,island_id: 100 }, // Σύνολο Περιφέρειας
};

 

export function getMapViewByRegion(codeArg) {
  let code = codeArg;
  try {
    if (!code) code = localStorage.getItem("selectedRegion") || "ro";
  } catch {
    code = "ro";
  }
  return REGION_VIEWS[code] || REGION_VIEWS.ro;
}
